module.exports = __webpack_public_path__ + "static/media/avatar-526x526.7bb752e1.png";